import { AbstractControl, ValidationErrors } from '@angular/forms';

const INVALID_SEQUENCES = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999'
];

export function onlyDigits(value: string): string {
  return (value || '').replace(/\D/g, '');
}

export function isValidCPF(value: string): boolean {
  const strCPF = onlyDigits(value);

  if (strCPF.length !== 11 || INVALID_SEQUENCES.indexOf(strCPF) !== -1) {
    return false;
  }

  let sum = 0;
  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
  }

  let rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  if (rest !== parseInt(strCPF.substring(9, 10), 10)) {
    return false;
  }

  sum = 0;
  for (let k = 1; k <= 10; k++) {
    sum = sum + parseInt(strCPF.substring(k - 1, k), 10) * (12 - k);
  }

  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  return rest === parseInt(strCPF.substring(10, 11), 10);
}

export function cpfValidator(control: AbstractControl): ValidationErrors {
  if (!control.value) {
    return null;
  }

  return isValidCPF(control.value) ? null : { cpf: true };
}
